import { PeekSelect, PeekSelectOption, PeekStack, PeekTextField, useTheme } from "@piiqtechnologies/ui-components";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
const CancelFields = ({ row, notesAndReasonsByRequestId, onReasonSelected, onNotesChanged, }) => {
    const theme = useTheme();
    const intl = useIntl();
    const { reason, comment } = useMemo(() => {
        if (!notesAndReasonsByRequestId[row._id]) {
            return {
                reason: "",
                comment: "",
            };
        }
        return notesAndReasonsByRequestId[row._id];
    }, [notesAndReasonsByRequestId]);
    const PRE_DEFINED_REASONS = useMemo(() => {
        return [
            intl.formatMessage(messages.reasonNeedToReschedule),
            intl.formatMessage(messages.reasonSpaceNotReady),
            intl.formatMessage(messages.reasonSpaceIsNoLongerAvailable),
            intl.formatMessage(messages.reasonNoLongeWantToCapture),
        ];
    }, []);
    return (React.createElement(PeekStack, { direction: "row", width: "calc(100% - 30px)", spacing: theme.spacing(1), m: 1 },
        React.createElement(PeekSelect, { value: reason || PRE_DEFINED_REASONS[0], onChange: (e) => onReasonSelected(row._id, e.target.value), sx: { width: "calc(100% - 40px)" } }, PRE_DEFINED_REASONS.map((preDefReason) => (React.createElement(PeekSelectOption, { key: preDefReason, value: preDefReason, sx: { justifyContent: "left !important" } }, preDefReason)))),
        React.createElement(PeekTextField, { onBlur: (e) => onNotesChanged(row._id, e.target.value), defaultValue: comment, placeholder: "Notes (optional)", sx: {
                backgroundColor: theme.palette.common.white,
                borderRadius: "8px",
                width: "calc(100% - 40px)",
                ".MuiInputBase-root": {
                    height: "38px",
                    borderRadius: "8px",
                },
            } })));
};
export default CancelFields;
